'use client'

import {
  errorRoute,
  homeRoute,
  kpisRoute,
  labResultsRoute,
  loginRoute,
  privacyPolicyRoute,
  profileRoute,
  recommendationsRoute,
  shopOrdersPageDynamicSignature,
  shopOrdersRoute,
  termsOfUseConsentRoute,
  termsOfUseRoute,
} from '../../../common/constants/routes'
import { useAccount } from '../../auth/hooks/useAccount'

export const unauthenticatedEnabledPages = [
  loginRoute,
  homeRoute,
  errorRoute,
  termsOfUseRoute,
  termsOfUseConsentRoute,
  privacyPolicyRoute,
]

export const authenticatedEnabledPages = [
  labResultsRoute,
  kpisRoute,
  profileRoute,
  homeRoute,
  privacyPolicyRoute,
  termsOfUseRoute,
  shopOrdersRoute,
  recommendationsRoute,
]

export const authenticatedEnabledDynamicSignatures = [shopOrdersPageDynamicSignature]

export type UseReconstructionHandlerReturn = ReturnType<typeof useReconstructionHandler>
export function useReconstructionHandler() {
  const { isLoading } = useAccount()

  const showLoadingUi = isLoading
  const showUnderConstructionUi = false
  const showLimitedUi = false
  const redirectToHome = false

  return { showLoadingUi, showUnderConstructionUi, showLimitedUi, redirectToHome }
}
